// @flow

import styled from 'styled-components';

import DisplayText from './DisplayText';

export default styled(DisplayText)`
  color: ${props => props.theme[props.themeColor] || props.color || props.theme.contentTextColor};
  font-size: ${props => props.fontSize || '16px'};
  line-height: ${props => props.lineHeight || '24px'};
  opacity: ${props => props.opacity || 1};
  white-space: ${props => props.whiteSpace || 'normal'};
`;
